<template>
  <div>
    <header-status />
    <div class="conteudo" v-if="plan">
      <v-layout wrap row>
        <v-flex xs12 mt-2>
          <v-card v-if="!plan.plan || plan.apple_product_id">
            <v-card-text
              v-if="!plan.canceled"
            >Sua assinatura está ativa, desde {{plan.current_period_start}} para maiores detalhes entre na Apple Store</v-card-text>
            <v-card-text
              v-else
            >Seu plano foi cancelado, encerra em: {{plan.current_period_end | formatDate}}</v-card-text>
          </v-card>
          <v-card v-else>
            <v-card-title>
              <span class="headline">MEU PLANO</span>
            </v-card-title>
            <v-card-text>
              <strong>Valor Mensal {{plan.plan.price | formatMoney}}</strong>
            </v-card-text>
            <v-card-actions>
              <div
                v-if="plan.canceled"
              >Seu plano foi cancelado, encerra em: {{plan.current_period_end | formatDate}}</div>
              <v-spacer v-if="!plan.canceled"></v-spacer>
              <v-btn v-if="!plan.canceled" color="red" text @click="dialog = true">CANCELAR PLANO</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>

    <dialog-loader :active="loading"></dialog-loader>
    <v-dialog v-model="dialog" width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">DESEJA REALMENTE CANCELAR ESTE PLANO?</span>
        </v-card-title>
        <v-card-text>Você não mais podera assistir as aulas nem fazer os exercícios</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click.native="cancel">SIM, QUERO CANCELAR</v-btn>
          <v-btn color="primary" text @click="dialog = false">NÃO</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { authService } from "../plugins/firebase";
export default {
  data() {
    return {
      dialog: false,
      loading: true,
      plan: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.plan = await this.getPlan(config);
      this.loading = false;
    },
    getPlan(config) {
      return this.$http
        .get(this.$SERVE + "/students/subscription", config)
        .then(response => {
          return response.data;
        });
    },
    async cancel() {
      this.loading = true;
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http
        .post(this.$SERVE + "/students/payments/cancel", {}, config)
        .then(response => response.data)
        .then(json => {
          this.loading = false;
          alert("Cancelamento realizado com sucesso!");
          window.location.href = "/home";
        })
        .catch(error => {
          this.loading = false;
          if (error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          } else {
            alert("Ocorreu uma falha, tente novamente!");
          }
        });
    }
  }
};
</script>

